import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FormSearch from "./forms/FormSearch";
import { Col, Row } from "react-bootstrap";
import Listing from "./components/Listing";
import { Plus } from "lucide-react";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { apiSend, getRoute } from "@services/axios";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import Paginate from "@components/Paginate";
import { saveChangeStatus } from "./Action";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useModal } from "@components/ModalContext";
import FormNewUser from "./forms/FormNewUser";
const { confirm } = Modal;
const queryClient = new QueryClient();
const Home = (props) => {
  const { t } = useTranslation();
  const { openModal, setTitle } = useModal();

  const newUser = async () => {
    setTitle(t("new_user"));
    openModal(<FormNewUser t={t} />);
  };
  return (
    <>
      <Row className="align-items-center">
        <Col xs="4" sm="6" className="my-2">
          <h2 className={`fs-3 ${props.theme.text}`}>{t("users")}</h2>
        </Col>
        <Col xs="8" sm="6" className="my-2">
          <div
            className={`d-flex justify-content-end align-items-center ${props.theme.text}`}
          >
            <a
              role="button"
              className="text-white bg-blue p-2 gap-1"
              title={t("add_your_product")}
              onClick={newUser}
            >
              <Plus size={25} strokeWidth={1.2} />
              <span className="me-1 ">{t("add_user")}</span>
            </a>
          </div>
        </Col>
      </Row>{" "}
      <QueryClientProvider client={queryClient}>
        <LoadUsers {...props} />
      </QueryClientProvider>
    </>
  );
};

function LoadUsers(props) {
  const { t } = useTranslation();

  const payload = {
    input_search: "",
    status: "",
  };

  const { isLoading, error, data } = useQuery("repoData", () =>
    apiSend(getRoute("USER_LIST"), "post", payload)
  );
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={t("not_found")} />;
  if (data?.data?.request?.status !== true) {
    return <LoadError message={t("not_found")} />;
  }

  return (
    <PrintDataUser
      total={data?.data?.result?.total}
      data={data?.data?.result?.data}
      t={t}
      {...props}
    />
  );
}

export default Home;

function PrintDataUser(props) {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectInput, setSelectInput] = useState("");
  const [dataUser, setDataUser] = useState(props.data);
  const [total, setTotal] = useState(props.total);
  const t = props.t;

  const getSelectInput = async (e) => {
    setSelectInput(e.target.value);
  };

  const reset = async (page) => {
    const payload = {
      input_search: "",
      status: "",
    };
    document.getElementById("searchText").value = "";
    getDataUser(payload, page);
  };

  const loadData = async (page) => {
    const payload = {
      input_search: selectInput,
      status: selectedStatus?.value ? selectedStatus?.value : "",
    };
    getDataUser(payload, page);
  };

  const getDataUser = async (payload, page) => {
    window.loader(1);
    const response = await apiSend(
      getRoute("USER_LIST") + "?page=" + page,
      "post",
      payload
    );
    if (response?.data?.result?.total >= 0) {
      setDataUser(response?.data?.result.data);
      setTotal(response?.data?.result?.total);
    }
    window.loader(0);
  };

  const handleChangeStatus = async (item, index) => {
    const titleConfirm = {
      disabled: t("do_you_really_want_to_deactivate_this_user"),
      enabled: t("do_you_really_want_to_activate_this_user"),
      deleted: t("do_you_really_want_to_delete_this_user"),
    };
    var status = item.status === "enabled" ? "disabled" : "enabled";
    item.status = status;
    var data = dataUser;
    data[index] = item;
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: <p>{titleConfirm[item.status]}</p>,
      okText: t("confirm"),
      cancelText: t("cancel"),
      onOk: async () => {
        const res = await saveChangeStatus(item.id, status);
        if (res === true) {
          setTimeout(() => {
            setDataUser(data);
          }, "1000");
        }
      },
      onCancel() {},
    });
  };
  return (
    <Row>
      <Col md="12" className="my-2 ">
        <div className="sticky">
          <FormSearch
            mode={props.profile.mode}
            t={t}
            selectInput={selectInput}
            getSelectInput={getSelectInput}
            loadData={loadData}
            reset={reset}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
          />
        </div>
      </Col>
      <Col md="12" className="my-2">
        <Paginate
          total={total}
          itemsPerPage={`20`}
          loadData={loadData}
          component={
            <Listing
              t={t}
              mode={props.profile.mode}
              profile={props.profile.data}
              data={dataUser}
              handleChangeStatus={handleChangeStatus}
            />
          }
        />
      </Col>
    </Row>
  );
}
